import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';

const selectNextState = createSelector(selectState, (state) => state.next);

export const selectNext = createSelector(selectNextState, (state) => state.data);
export const selectNextLoading = createSelector(selectNextState, (state) => state.loading);
export const selectNextLoaded = createSelector(selectNextState, (state) => state.loaded);
